<template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    :fixed-header="true"
    :search="search"
    item-key="idperfil"
    class="elevation-2 table-acl-resposivo"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Cadastro de Perfil</v-toolbar-title>
        <v-spacer />
        <v-text-field
          class="mr-4"
          v-model="search"
          outlined
          dense
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
        <v-dialog persistent v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on">Novo</v-btn>
          </template>
          <v-card>
            <v-card-title class="mb-7">{{ formTitle }}</v-card-title>
            <v-card-text
              class="d-flex align-center mb-6"
              style="min-height: 55vh"
            >
              <v-container>
                <v-row>
                  <v-col class="pa-0" cols="12" xs="12">
                    <v-text-field
                      outlined
                      v-model="editedItem.descricao_perfil"
                      label="Nome Perfil*"
                      autofocus
                      :error-messages="nameErrors"
                      @input="$v.editedItem.descricao_perfil.$touch()"
                      @blur="$v.editedItem.descricao_perfil.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col class="pa-0" cols="12" xs="12" v-show="!filtrar_admin">
                    <v-select
                      v-model="editedItem.admin"
                      :items="admin"
                      chips
                      label="Perfil Administrador"
                      height="10"
                      outlined
                      item-value="value"
                      item-text="value"
                      style="margin-right: 5px"
                      :error-messages="adminErrors"
                      @input="$v.editedItem.admin.$touch()"
                      @blur="$v.editedItem.admin.$touch()"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.src_modulo="{ item }">
      <v-icon>{{ item.src_modulo }}</v-icon>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon title="Editar Módulo" class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
      <v-icon title="Remover Módulo" @click="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import AclAPI from "./../../api/acl";

export default {
  props: ["filtrar_admin"],
  name: "Acl",
  data: () => ({
    dialog: false,
    atualizar: 0,
    search: "",
    headers: [
      { text: "ID", value: "idperfil", width: "80px", align: "center" },
      { text: "Perfil", align: "left", value: "descricao_perfil" },
      { text: "Administrador", value: "admin", align: "center" },
      {
        text: "",
        value: "action",
        sortable: false,
        width: "100px",
        align: "center",
      },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      descricao_perfil: "",
      admin: "",
    },
    defaultItem: {
      descricao_perfil: "",
      admin: "",
    },

    admin: [{ value: "S" }, { value: "N" }],
  }),

  validations: {
    editedItem: {
      descricao_perfil: {
        required,
      },
      admin: {
        required() {
          if (this.filtrar_admin) {
            return true;
          } else {
            if (this.editedItem.admin) return true;
            else return false;
          }
        },
      },
    },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.editedItem.descricao_perfil.$dirty) return errors;
      !this.$v.editedItem.descricao_perfil.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    adminErrors() {
      const errors = [];
      if (!this.$v.editedItem.admin.$dirty) return errors;
      !this.$v.editedItem.admin.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Novo Perfil" : "Editar Perfil";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        filtrar_admin: this.filtrar_admin ? "S" : "N",
      };

      AclAPI.getPerfis(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.desserts = response.data.perfis;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      this.$store.dispatch("loading/habilitarLoading", false);
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      if (confirm("Deseja remover o Perfil?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          AclAPI.delPerfil(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};

                this.initialize();

                //atualizar permissao
                this.$emit("atualizarPermUsu", (this.atualizar += 1));
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      } else {
        this.editedItem = {};
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
      this.$v.$reset();
    },

    save() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          idperfil: this.editedItem.idperfil,
          descricao_perfil: this.editedItem.descricao_perfil,
          admin: this.filtrar_admin ? "N" : this.editedItem.admin,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          AclAPI.addPerfil(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.initialize();

                //atualizar permissao
                this.$emit("atualizarPermUsu", (this.atualizar += 1));
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );

        this.close();
      }
    },
  },
};
</script>
<style></style>
